import { uniqueId, defaultsDeep } from "lodash";

//
// Action types
//

export const OPEN_WYSIWYG_IMAGE_FORM = "OPEN_WYSIWYG_IMAGE_FORM";
export const CLOSE_WYSIWYG_IMAGE_FORM = "CLOSE_WYSIWYG_IMAGE_FORM";

//
// Action creators
//

export function openWysiwygImageForm(fieldName) {
  return {
    type: OPEN_WYSIWYG_IMAGE_FORM,
    fieldName
  };
}

export function closeWysiwygImageForm(fieldName) {
  return {
    type: CLOSE_WYSIWYG_IMAGE_FORM,
    fieldName
  };
}

function ensureFieldFor(state, key, fieldName) {
  const newState = { ...state };
  defaultsDeep(newState, { [key]: { [fieldName]: {} } });
  return newState;
}

function openWysiwygImageFormHandler(state, fieldName) {
  const newState = ensureFieldFor(state, "imageForm", fieldName);

  // Set our field in the form as open
  newState.imageForm[fieldName] = {
    isOpen: true,
    formKey: uniqueId("WysiwygImageButton:")
  };

  return newState;
}

function closeWysiwygImageFormHandler(state, fieldName) {
  const newState = ensureFieldFor(state, "imageForm", fieldName);

  // Set our field in the form as closed
  delete newState.imageForm[fieldName];

  return newState;
}

//
// Reducer and handlers
//
export default function alertsReducer(state, action) {
  switch (action && action.type) {
    case OPEN_WYSIWYG_IMAGE_FORM:
      return openWysiwygImageFormHandler(state, action.fieldName);

    case CLOSE_WYSIWYG_IMAGE_FORM:
      return closeWysiwygImageFormHandler(state, action.fieldName);

    default:
      return state || { imageForm: {} };
  }
}
